
export default {
  name: "ContentType1",
  props: {
    introList: {
      type: Array,
      default () {
        return []
      }
    },
    imageList: {
      type: Array,
      default () {
        return []
      }
    },
    contentStyle: {
      type: Object,
      default () {
        return {}
      }
    },
    imageStyle: {
      type: Object,
      default () {
        return {}
      }
    },
    classProps: {
      type: String,
      default: ''
    }
  }
}
